import { Icon } from '../../icon/icon';
import './LeftCabinetDesignSidebar.scss';
import ButtonIconMediumChangeIconColor from '../../common/ButtonIconGhost/ButtonIconMediumChangeIconColor';
import { useTranslation } from 'react-i18next';

const LeftCabinetDesignSidebar = ({ activeKey, setActiveKey }) => {
  const { t } = useTranslation();
  const items = [
    [
      {
        icon: Icon.ICSpecial2,
        key: '1',
        label: t('Structure'),
      },
      {
        label: t('Partition'),
        icon: Icon.ICSpecial5,
        key: '2',
      },
      {
        label: t('Accessories'),
        icon: Icon.ICSpecial6,
        key: '3',
      },
      {
        label: t('Door'),
        icon: Icon.ICSpecial3,
        key: '4',
      },
      {
        label: t('Lighting'),
        icon: Icon.ICSpecial7,
        key: '5',
      },
    ],
  ];

  return (
    <div className="cabinet-sidebar-design-left">
      {items.map((item, key) => {
        return (
          <div className="container-button" key={key}>
            {item.map((btn, key2) => {
              return (
                <div
                  key={key2}
                  className="flex flex-col items-center gap-4 self-stretch"
                >
                  <ButtonIconMediumChangeIconColor
                    style={{ width: '36px', height: '36px' }}
                    icon={btn.icon}
                    onClick={() => {
                      if (activeKey === btn.key) setActiveKey();
                      else setActiveKey(btn.key);
                    }}
                    active={activeKey === btn.key}
                  />
                  <span className="support-text-medium">{btn.label}</span>
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
};

export default LeftCabinetDesignSidebar;
